import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { CircularProgress } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";

import Slideover, { SlideoverProps } from "components/Slideover";
import ActiveUsers from "./ActiveUsers";
import ArchivedUsers from "./ArchivedUsers";
import {
  useSystemUsers,
  useActiveSystemUsers,
  useAdminSystemUsers,
  useArchivedSystemUsers,
} from "data/admin/systemUsers";

type Props = SlideoverProps & {
  onClose: () => void;
};

const SystemUsers: React.FC<Props> = ({ onClose, ...slideoverProps }) => {
  const [t] = useTranslation();
  const [{ isLoading }, { getSystemUsers }] = useSystemUsers();
  const [{ users: activeUsers }] = useActiveSystemUsers();
  const [{ users: adminUsers }] = useAdminSystemUsers();
  const [{ users: archivedUsers }] = useArchivedSystemUsers();
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    {
      label: t("systemUsers.tabs.activeUsers"),
      content: <ActiveUsers users={activeUsers} />,
    },
    {
      label: t("systemUsers.tabs.adminUsers"),
      content: <ActiveUsers users={adminUsers} />,
    },
    {
      label: t("systemUsers.tabs.archivedUsers"),
      content: <ArchivedUsers users={archivedUsers} />,
    },
  ];

  useEffect(() => {
    getSystemUsers();
  }, [getSystemUsers]);

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Slideover
      HeaderComponent={<Typography variant="h4">{t("systemUsers.title")}</Typography>}
      onClose={onClose}
      {...slideoverProps}
    >
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Tabs value={activeTab} onChange={(_, tab) => setActiveTab(tab)}>
            {tabs.map((tab, i) => (
              <Tab key={tab.label} label={tab.label} value={i} />
            ))}
          </Tabs>
        </Grid>
        <Grid item>{tabs[activeTab].content}</Grid>
      </Grid>
    </Slideover>
  );
};

export default SystemUsers;
